import React from 'react';

import FilterDatepickerPair from 'components/search_sidebar/filter_datepicker_pair';

import type { Filters } from './types';

type Slice = Pick<Filters, 'dateRange'>;
interface Props extends Slice {
  onChange: (changes: Slice) => void;
}

export default function ActivityDateFilter({ dateRange, onChange }: Props) {
  return (
    <FilterDatepickerPair
      filter={dateRange}
      inputsOnly
      maxPlaceholder="To"
      minPlaceholder="From"
      valueKeys={['min', 'max']}
      onChange={(value, key) => onChange({ dateRange: { ...dateRange, [key]: value } })}
    />
  );
}
